export default __webpack_public_path__ + "static/media/print.bf657583.svg";